import * as React from "react";
import { forwardRef } from "react";
const SvgMegaphone = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M45.605 16.898c-1.846 6.947-4.74 15.772-12 24.721-7.02 8.652-20.433 16.672-31.859 23.68l1.28 2.378L0 70.882l1.396 2.591 1.396 2.59 4.345-.767 1.28 2.378h.002v.008l.036-.016c1.292-.186 4.826-1.76 8.982-3.647-.014 1.537-.605 14.85 4.166 17.567.918.522 5.903-.312 9.902-1.89L34.3 84.68c-3.074-4.576-5.82-15.02-5.612-15.488 4.542-1.87 9.118-3.755 13.08-4.502 10.688-2.018 22.04.033 31.19 2.962v-.004c-2.671-7.587-5.675-15.08-9.287-22.392l2.46-2.142c-.103-1.389-.258-2.692-.984-4.002-.696-1.329-1.697-2.172-2.802-3.023l-3.145.877c-4.119-7.036-8.727-13.664-13.595-20.069M91.705 23.444a1.36 1.36 0 0 0-.596.165L69.834 35.076a1.33 1.33 0 1 0 1.262 2.34L92.37 25.949a1.328 1.328 0 0 0-.666-2.505m6.996 17.11a1.4 1.4 0 0 0-.354.04l-23.52 5.568a1.331 1.331 0 1 0 .614 2.59l23.517-5.572a1.328 1.328 0 0 0-.257-2.625M81.264 8.259a1.33 1.33 0 0 0-.925.374L62.756 25.215a1.329 1.329 0 1 0 1.824 1.933l17.583-16.58a1.328 1.328 0 0 0-.899-2.31" />
  </svg>
);
const ForwardRef = forwardRef(SvgMegaphone);
export default ForwardRef;
